// extracted by mini-css-extract-plugin
export default {"containerBase":"base_containerBase__ztWuz"};